import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface DeleteClaimGroupByIdCommandArgs {
  claimGroupId: string;
}

export const deleteClaimGroupByIdRequest = ({
  claimGroupId,
}: DeleteClaimGroupByIdCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}`,
  config: { method: SUPPORTED_METHODS.DELETE },
});

export const deleteClaimGroupByIdCommand = async (
  args: DeleteClaimGroupByIdCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    return await executeQuery<BaseBackResponse>(
      deleteClaimGroupByIdRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
